import {t} from "i18next";

export const projectsStatusHandler = (status) => {
    switch (status){
        case 'upcoming':
            return (t('Ожидается'));
        case  'investable':
            return (t('Открыт для инвестрирования'));
        case  'participation_allowed':
            return (t('Открыт для участия'));
        case  'ended':
            return (t('Завершен'));
        default:
            return 'Unknown'
    }
}